import { gql } from "@apollo/client";

//To upload the material in E-Books
export const UPLOAD_MATERIAL = gql`
mutation insertMaterialsForEbooks($filename: String!, $filepath: String!, $filesize: BigInt!, $isclassroom: Boolean!, $lId: UUID!, $sjId: UUID!, $type: String!, $cId: UUID!, $authorName: String = null, $coverImagePath: String = null, $filetype: String = null) {
  insertMaterialIntoEbookMaterials(
    input: {pFilename: $filename, pFilepath: $filepath, pFilesize: $filesize, pIsClassroom: $isclassroom, pLibraryId: $lId, pSubjectId: $sjId, pTypeName: $type, pClassroomId: $cId, pCoverImagePath: $coverImagePath, pAuthorName: $authorName, pFiletype: $filetype}
  ) {
    clientMutationId
  }
}`;

//To view materials in E-Books
export const VIEW_ALL_EBOOK_MATERIAL = gql`
query getAllMaterialsForEbookType($lId: UUID!, $sjId: UUID!, $searchInput: String = "%", $type: String!, $cId: UUID!, $limit: Int = null, $offset: Int = null, $isclassroom: [Boolean!] = [true, false]) {
  getMaterialsFromEbookType(
    pClassroomId: $cId
    pLibraryId: $lId
    pSubjectId: $sjId
    pTypeName: $type
    filter: {filename: {likeInsensitive: $searchInput}, fileDeletedAt: {isNull: true}, isclassroom: {in: $isclassroom}}
    first: $limit
    offset: $offset
  ) {
    nodes {
      filename
      filesize
      isclassroom
      typeName
      coverimagepath
      authorname
      filepath
      fileId
      filetype
      feedId
    }
    totalCount
  }
}`;

export const UPDATE_EBOOK_MATERIAL = gql`
mutation updateEbookMaterials($cId:UUID!,$fId:UUID!,$isClassroom:Boolean!,$lId:UUID!,$sjId:UUID!,$type:String!) {
  updateEbookMaterials(
    input: {pClassroomId:$cId, pFileId: $fId, pIsClassroom: $isClassroom, pLibraryId: $lId, pSubjectId: $sjId, pTypeName: $type}
  ) {
    clientMutationId
  }
}`;

export const DELETE_EBOOK_MATERIAL = gql`
mutation deleteEbookMaterials($cId: UUID!, $fId: UUID!, $lId: UUID!, $sjId: UUID!, $type: String!) {
  deleteEbookMaterials(
    input: {pClassroomId: $cId, pFileId: $fId, pLibraryId: $lId, pSubjectId: $sjId, pTypeName: $type}
  ) {
    clientMutationId
  }
}`;

export const CONVERT_PPT_DOCS_TO_PDF = gql`
query convertFileType($key: String) {
  convertFile(key: $key)
}`;
